import React, { useState } from 'react';
import {
  validarReceita,
  validarCrm,
} from '../../services/validacaoReceitaService';
import './ValidacaoReceitaPage.css';
import ExternalPageHeader from '../../components/external/ExternalPageHeader';
import ExternalPageFooter from '../../components/external/ExternalPageFooter';
import logoGreen from '../../assets/logo-green.svg'; // Importando o logo corretamente

function ValidacaoReceitaPage() {
  const [crm, setCrm] = useState('');
  const [token, setToken] = useState('');
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState(null);
  const [isCrmValid, setIsCrmValid] = useState(false);

  const handleCrmChange = (e) => {
    setCrm(e.target.value);
  };

  const handleTokenChange = (e) => {
    setToken(e.target.value);
  };

  const handleCrmValidation = async () => {
    setErro(null);
    setResultado(null);

    // Validação básica de CRM
    if (!crm) {
      setErro('Por favor, insira um Código de Acesso.');
      return;
    }

    try {
      const crmIsValid = await validarCrm(crm);

      if (crmIsValid) {
        setIsCrmValid(true);
      } else {
        setErro(
          'Código de acesso inválido. Verifique o código e tente novamente.'
        );
      }
    } catch (error) {
      console.error('Erro na validação do CRM:', error);
      setErro('Erro na validação do Código de Acesso.');
    }
  };

  const handleValidarClick = async () => {
    setErro(null);
    setResultado(null);

    // Validação básica de token
    if (!token) {
      setErro('Por favor, insira o token da receita.');
      return;
    }

    try {
      if (!isCrmValid) {
        setErro('Valide o código de acesso primeiro.');
        return;
      }

      const receita = await validarReceita(token);

      if (receita) {
        let dataEmissao;

        // Verifica se dataCriacao é um timestamp ou uma string
        if (!isNaN(receita.dataCriacao)) {
          dataEmissao = new Date(receita.dataCriacao).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
        } else if (typeof receita.dataCriacao === 'string') {
          dataEmissao = new Date(receita.dataCriacao).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
        } else {
          dataEmissao = 'Data inválida';
        }

        setResultado(
          `Receita digital verificada com sucesso! Emitida por ${receita.tituloMedico} ${receita.nomeMedico} em ${dataEmissao}. Obrigado por utilizar o Plantão Fácil.`
        );
      } else {
        setErro('Token inválido ou receita não gerada pelo Plantão Fácil.');
      }
    } catch (error) {
      console.error('Erro na validação da receita:', error);
      setErro('Erro na validação da receita.');
    }
  };

  return (
    <div>
      <ExternalPageHeader />
      <div className="validacao-receita-page-container">
        <header className="validacao-receita-page-header">
          <img
            src={logoGreen}
            alt="Logo Plantão Fácil"
            className="validacao-receita-logo"
          />
          <h1>Validação de Receita Médica Digital</h1>
        </header>
        <main className="validacao-receita-page-content">
          {!isCrmValid ? (
            <div className="validacao-crm-form">
              <label htmlFor="crm" className="validacao-receita-label">
                Insira o Código de Acesso:
              </label>
              <input
                type="text"
                id="crm"
                value={crm}
                onChange={handleCrmChange}
                className="validacao-receita-input"
                aria-label="Campo para inserir o código de acesso"
                placeholder="Digite o código de acesso"
              />
              <button
                onClick={handleCrmValidation}
                className="validacao-receita-button"
                aria-label="Botão para validar o código de acesso"
              >
                Validar Código de Acesso
              </button>
            </div>
          ) : (
            <div className="validacao-receita-form">
              <label htmlFor="token" className="validacao-receita-label">
                Insira o Token da Receita:
              </label>
              <input
                type="text"
                id="token"
                value={token}
                onChange={handleTokenChange}
                className="validacao-receita-input"
                aria-label="Campo para inserir o token da receita médica digital"
                placeholder="Digite o token da receita"
              />
              <button
                onClick={handleValidarClick}
                className="validacao-receita-button"
                aria-label="Botão para validar a receita médica digital"
              >
                Validar Receita
              </button>
            </div>
          )}
          {resultado && (
            <p
              className="validacao-receita-resultado"
              role="alert"
              aria-live="polite"
            >
              {resultado}
            </p>
          )}
          {erro && (
            <p
              className="validacao-receita-erro"
              role="alert"
              aria-live="polite"
            >
              {erro}
            </p>
          )}
        </main>
      </div>
      <ExternalPageFooter />
    </div>
  );
}

export default ValidacaoReceitaPage;
